export default __webpack_public_path__ + "bf5c92091fb3c0eb4be7b9d1550f3d96.webp";